import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { THEMES } from '../../../../configs/LayoutConfig';
import ConstCommon from '../../../common/Const';
import ToggleSwitch from '../../../common/toggle-switch/ToggleSwitch';
import {
  fetchSystemAlert,
  REDUCER_NAME as ALERT_REDUCER_NAME,
  subscribeSystemAlert,
} from '../../../main-layout/header/right/alerts/reducer';
import Table from '../../../common/table/Table';
import currentState from './../../../helpers/CurrentState';

const Plus = require('../../../../assets/images/svg/fundamental/plus.svg');
const Minus = require('../../../../assets/images/svg/fundamental/minus.svg');
const PlusBlack = require('../../../../assets/images/svg/fundamental/plus_black.svg');
const MinusBlack = require('../../../../assets/images/svg/fundamental/minus_black.svg');

class AlertSystemTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expands:
        currentState.get(ConstCommon.listComponent.Alerts, 'expands') || {},
    };
  }

  componentDidMount() {
    const { fetchSystemAlert } = this.props;
    fetchSystemAlert({ date: new Date().getTime() });
  }

  componentDidUpdate(prevProps) {
    const { locale, fetchSystemAlert } = this.props;
    if (locale !== prevProps.locale) {
      fetchSystemAlert();
    }
  }

  getPlusIcon = () => {
    const { theme } = this.props;
    return theme === THEMES.DARK ? Plus : PlusBlack;
  };

  getMinusIcon = () => {
    const { theme } = this.props;
    return theme === THEMES.DARK ? Minus : MinusBlack;
  };

  getExpandIcon = bool => {
    const { isExpandAll } = this.state;
    const MinusImg = this.getMinusIcon();
    const PlusImg = this.getPlusIcon();
    return (
      <img
        className="expand-status-icon"
        src={bool || isExpandAll ? MinusImg : PlusImg}
        alt="status"
      />
    );
  };

  getSubscribeParams = (item, isSubscribe) => {
    if (item.isGroup) {
      return {
        subscribeType: 'Group',
        code: item.code,
        subscribe: isSubscribe,
      };
    }

    return {
      subscribeType: 'Alert',
      code: item.alertCode,
      subscribe: isSubscribe,
    };
  };

  onToggleSubscribe = (isSubscribe, item) => {
    const { subscribeSystemAlert } = this.props;
    subscribeSystemAlert(this.getSubscribeParams(item, isSubscribe));
  };

  toggleExpandRow = code => {
    const { expands } = this.state;
    const map = {
      [true]: false,
      [false]: true,
      [undefined]: true,
    };
    const expandState = {
      ...expands,
      [code]: map[expands[code]],
    };
    this.setState({
      expands: expandState,
    });
    currentState.add(ConstCommon.listComponent.Alerts, 'expands', expandState);
  };

  getSchema = () => {
    const { expands } = this.state;
    return [
      {
        title: I18n.t('alerts.tableTitle.name'),
        key: 'alertGroup',
        disableSort: true,
        render: (text, item) => {
          if (item.isGroup) {
            return (
              <div
                className="d-flex align-items-center"
                onClick={() => this.toggleExpandRow(item.code)}
              >
                {this.getExpandIcon(expands[item.code])}
                {item.name}
              </div>
            );
          }
          return (
            <div className={item.alertGroupCode ? 'alert-item-child' : ''}>
              {item.alertName}
            </div>
          );
        },
      },
      {
        title: (
          <div className="text-center">
            {I18n.t('alerts.tableTitle.active')}
          </div>
        ),
        isHtml: true,
        key: 'subscribed',
        disableSort: true,
        thStyle: {
          width: '80px',
        },
        render: (_, item) => {
          return (
            <div className="text-center">
              <ToggleSwitch
                isActive={item.subscribed}
                handleToggle={prevIsSubscribe =>
                  this.onToggleSubscribe(!prevIsSubscribe, item)
                }
              />
            </div>
          );
        },
      },
    ];
  };

  getDataFromRedux = state => state[ALERT_REDUCER_NAME].systemAlertById;

  getIds = () => {
    const { expands } = this.state;
    const { systemAlertById } = this.props;
    let ids = [];
    Object.keys(systemAlertById).forEach(key => {
      if (systemAlertById[key].isGroup) {
        ids.push(key);
        if (expands[systemAlertById[key].code]) {
          ids = ids.concat(systemAlertById[key].children);
        }
      }
    });

    return ids;
  };

  render() {
    const { isLoading } = this.props;
    return (
      <Table
        isLoading={isLoading}
        getDataFromRedux={this.getDataFromRedux}
        ids={this.getIds()}
        schema={this.getSchema()}
      />
    );
  }
}

AlertSystemTable.propTypes = {
  systemAlertIds: PropTypes.array.isRequired,
  systemAlertById: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  subscribeSystemAlert: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  systemAlertIds: state[ALERT_REDUCER_NAME].systemAlertIds,
  systemAlertById: state[ALERT_REDUCER_NAME].systemAlertById,
  isLoading: state[ALERT_REDUCER_NAME].isSystemAlertLoading,
  locale: state.i18n.locale,
  theme: state.theme,
});

const mapDispatchToProps = {
  subscribeSystemAlert,
  fetchSystemAlert,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertSystemTable);
